module.exports = __webpack_public_path__ + "2c9b35ee02aa2991b78b0d02a93eb1cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/ads/disney_sample_ad.jpg
// module id = 1608
// module chunks = 0